/* global TFM */
import React from "react";
import PropTypes from "prop-types";
import { fetchJson } from "@xingternal/malt-network";
import { getPrefixedUrl } from "@xingternal/malt-util";
import { BannerSizes, AdStatus, PageNames, AdOrientation } from "./constants";
import { foragAdEngine } from "@xingternal/forag-ad-engine";
import styles from "./Ad.css";

class AdProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ads: {},
      customKeywords: false
    };

    if (typeof window !== "undefined") {
      let pageUrl = document.location.pathname;
      let appName = pageUrl.split("/")[1];

      if (PageNames[appName]) {
        window.adsc_adunit2 = PageNames[appName];
      }
    }
  }

  render() {
    const { customKeywords } = this.state;
    const { logoutAd } = this.props;

    if (customKeywords) {
      return <div className={logoutAd ? styles.logoutAd : ''}> {this.props.children} </div>;
    } else {
      return null;
    }
  }

  componentDidMount() {
    const { logoutTracking, logoutAd } = this.props;

    if (typeof window === "undefined" || typeof TFM === "undefined") {
      return;
    }

    window._aeq = window._aeq || [];

    this.addForagEventListeners();

    if(logoutAd) {
      this.setGlobalAdVariables(logoutTracking);
    } else {
      this.fetchUserTargeting();
    }
  }

  conponentWillUnmount() {
    this.removeForagEventListeners();
  }

  setGlobalAdVariables = (data = {}) => {
    const { logoutAd } = this.props;

    let xingKeywords = {};

    Object.keys(data).forEach(key => {
      window["adsc_" + key] = window["adsc_" + key] || data[key];
    });

    Object.keys(data).forEach(key => {
      if(key.toLowerCase().includes('country')) {
        xingKeywords[key.toLowerCase()] = xingKeywords[key] || data[key];
      } else {
        xingKeywords['adsc_' + key] = xingKeywords["adsc_" + key] || data[key];
      }
    });

    window._aeq.push(['setGlobalOptions', {
      device: 'desktop',
      layout: 'homepage',
      mobile: false,
      category: logoutAd ? PageNames["logout"] : window.adsc_adunit2,
      siteName: 'xing' + logoutAd ? window.adsc_Country : window.adsc_country,
      customKeywords: xingKeywords,
    }]);

    this.setState({customKeywords: true});
  };

  fetchUserTargeting() {
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        method: "GET"
      }
    };

    const url = getPrefixedUrl("/targeting");

    fetchJson(url, options)
      .then(result => {
        this.setGlobalAdVariables(result);
      })
      .catch(err => {
        console.error("FETCH ERROR: ", err);
      });
  }

  placeAd = ad => {
    if (typeof TFM === "undefined") {
      return;
    }
    const { id, bannerType, adIndex } = ad;
    const { logoutAd } = this.props;

    if (bannerType.includes("DESKTOP_SKYSCRAPER_ANY") && !logoutAd) {
      window.addEventListener("scroll", this.onAdScroll.bind(null, ad), false);
      window.addEventListener("resize", this.onAdScroll.bind(null, ad), false);
    }

    window._aeq.push(['getAdTag', {
        containerId: id, // mandatory - DIV ID where the ad should be rendered
        orientation: AdOrientation[bannerType], // mandatory - this is a 'hor'(horizontal), 'ver'(vertical), 'oop'(out-of-page) or 'in'(in-stream) ad slot
        index: adIndex, // mandatory - this is the nth 'hor', 'ver', 'oop' or 'in' ad slot
    }]);
  };

  onAdScroll = ad => {
    let adElement = document.getElementById(ad.id);
    let contentRect = document.querySelector("main").getBoundingClientRect();
    let adAlignWithContent = window.innerHeight >= contentRect.bottom;

    const adHeight = adElement.getBoundingClientRect().height;
    const headerHeight = 68;

    // ad is aligned with the bottom content
    if (adAlignWithContent && contentRect.bottom < adHeight + headerHeight) {
      document.body.style.position = "relative";
      adElement.setAttribute(
        "style",
        "position:absolute;top:auto;bottom:667px;" // bottom size is 532px footer height plus 150px maring-top
      );
    } else {
      document.body.style.removeProperty("position");
      adElement.removeAttribute("style");
    }
  };

  getAdByEvent = event => {
    const adId = event.detail.container;
    const ad = this.state.ads[adId];

    if (!ad) {
      console.error(`Received event for unknown ad id ${adId}: `, event);
    }
    return ad;
  };

  getGlobalAdVariables() {
    return {
      kw: window.adsc_kw,
      device: window.adsc_device,
      adunit1: window.adsc_adunit1,
      adunit2: window.adsc_adunit2
    };
  }

  onAdReceived = event => {
    const ad = this.getAdByEvent(event);
    if (!ad) return;

    if (event.detail.isEmpty) {
      this.changeAdStatus(ad, AdStatus.EMPTY, event);
    } else {
      if (
        event.detail.type === "adexchange" &&
        BannerSizes[event.detail.size]
      ) {
        this.changeAdStatus(ad, AdStatus.READY, event);
      }
    }
  };

  onAdRendered = event => {
    const ad = this.getAdByEvent(event);
    if (!ad) return;

    if (event.detail.isFiller) {
      this.changeAdStatus(ad, AdStatus.EMPTY, event);
    } else {
      this.changeAdStatus(ad, AdStatus.READY, event);
    }
  };

  changeAdStatus(targetAd, status, event) {
    const adSlot = TFM.adSlot["tag" + event.detail.slot];
    const currentAd = adSlot.ads[adSlot.ads.length - 1];
    const adType = currentAd.type;
    const data = {
      status,
      adType: adType,
      adSize: currentAd.size,
    };

    targetAd.component.onStatusChanged(data);
  }

  addForagEventListeners() {
    window.addEventListener("adReceived", this.onAdReceived);
    window.addEventListener("adRendered", this.onAdRendered, false);
  }

  removeForagEventListeners() {
    window.removeEventListener("adReceived", this.onAdReceived);
    window.removeEventListener("adRendered", this.onAdRendered, false);
  }

  registerAd = async ad => {
    this.setState((prevState, props) => {
      const ads = Object.assign({}, prevState.ads);
      ads[ad.id] = ad;

      if (typeof TFM !== "undefined") {
        this.placeAd(ad);
      }

      return {
        ads
      };
    });
  };

  unregisterAd = async ad => {
    this.setState((prevState, props) => {
      const newAds = Object.assign({}, prevState.ads);
      delete newAds[ad.id];
      return {
        ads: newAds
      };
    });
  };

  destroyAd = async ad => {
    if (typeof TFM === "undefined") {
      return;
    }

    TFM.Tag.destroy(ad.id);
  };

  getChildContext() {
    return {
      ad: {
        registerAd: this.registerAd,
        unregisterAd: this.unregisterAd,
        destroyAd: this.destroyAd
      }
    };
  }
}

AdProvider.propTypes = {
  children: PropTypes.node.isRequired,
  logoutTracking: PropTypes.object,
  logoutAd: PropTypes.bool,
  nofence: PropTypes.bool
};

AdProvider.childContextTypes = {
  ad: PropTypes.shape({
    registerAd: PropTypes.func.isRequired,
    unregisterAd: PropTypes.func.isRequired,
    destroyAd: PropTypes.func.isRequired
  })
};

AdProvider.defaultProps = {
  logoutAd: false,
  nofence: false,
};

export default AdProvider;
